import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AdminPayrollList from './components/AdminPayrollList';
import AdminPayrollPayments from './components/AdminPayrollPayments';
import AdminPayrollReview from './components/AdminPayrollReview';

/**
 * Empivo staff dashboard: Onboardings list / Setup-fee payments -> review screen.
 * (Single component switching views, so no router change is needed.)
 */
const PayrollAdminDashboard = () => {
  const [selectedId, setSelectedId] = useState(null);
  const [view, setView] = useState('onboardings'); // 'onboardings' | 'payments'

  // Clicking the "Payroll Onboardings" sidebar link while already on this page gives a new `location.key`
  // (same URL, same component, so nothing remounts) -> use it to go back to the list.
  const location = useLocation();
  useEffect(() => {
    setSelectedId(null);
    setView('onboardings');
  }, [location.key]);

  if (selectedId) {
    return (
      <div className="min-h-screen bg-gray-100 px-3 py-6 md:px-6 md:py-10">
        <AdminPayrollReview id={selectedId} onBack={() => setSelectedId(null)} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 px-3 py-6 md:px-6 md:py-10">
      <div className="mx-auto mb-6 flex max-w-6xl gap-1 border-b border-gray-300">
        {[
          ['onboardings', 'Onboardings'],
          ['payments', 'Payments'],
        ].map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setView(key)}
            className={`-mb-px border-b-2 px-4 py-2 text-sm font-bold transition ${
              view === key ? 'border-blue-700 text-blue-700' : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {view === 'onboardings' ? <AdminPayrollList onOpen={setSelectedId} /> : <AdminPayrollPayments onOpen={setSelectedId} />}
    </div>
  );
};

export default PayrollAdminDashboard;